<div class="w-full max-w-3xl"  *transloco="let t; prefix: 'pages.profile-account'">
<!-- Profile Picture Section -->
<div class="mb-8 flex items-center gap-6">
    <!-- Image Container with Conditional Hover Actions -->
    <div class="relative group h-24 w-24 rounded-full bg-gray-100 shadow-md overflow-hidden">
      
      <!-- Avatar Image OR Placeholder Icon -->
      <ng-container *ngIf="profilePictureUrl; else iconFallback">
        <img
          [src]="profilePictureUrl"
          alt="{{t('profile-picture-alt')}}"
          class="h-24 w-24 rounded-full object-cover"
        />
      </ng-container>
  
      <ng-template #iconFallback>
        <div class="flex h-full w-full items-center justify-center">
          <mat-icon
            [svgIcon]="'heroicons_solid:user'"
            class="h-12 w-12 text-gray-400"
          ></mat-icon>
        </div>
      </ng-template>
  
      <!-- Overlay with Conditional Action -->
      <div
        class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <!-- Show REMOVE icon if avatar exists -->
        <ng-container *ngIf="profilePictureUrl; else editIcon">
          <mat-icon
            [svgIcon]="'heroicons_outline:trash'"
            class="text-white text-2xl cursor-pointer"
            (click)="removeAvatar(); $event.stopPropagation()"
          ></mat-icon>
        </ng-container>
  
        <!-- Else show EDIT icon -->
        <ng-template #editIcon>
          <mat-icon
            [svgIcon]="'heroicons_outline:pencil'"
            class="text-white text-2xl cursor-pointer"
            (click)="triggerFileInput(); $event.stopPropagation()"
          ></mat-icon>
        </ng-template>
      </div>
    </div>
  
    <!-- Button + Input -->
    <div class="flex flex-col justify-center">
      <button
        mat-flat-button
        type="button"
        color="primary"
        (click)="triggerFileInput()"
      >
      {{t('change-avatar')}}
      </button>
      <input
        type="file"
        hidden
        accept="image/*"
        #fileInput
        (change)="onProfilePicSelected($event)"
      />
      <div class="text-sm text-secondary mt-1">
        {{t('upload-square-image')}}
      </div>
    </div>
  </div>
  

    <!-- Form -->
    <form [formGroup]="accountForm">
        <!-- Section -->
        <div class="w-full">
            <div class="text-xl">Profile</div>
            <div class="text-secondary">
              {{t('follow-info-public')}}
            </div>
        </div>

        <div class="mt-8 grid w-full gap-6 sm:grid-cols-4">
            <!-- Name -->
            <div class="sm:col-span-4">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>{{t('name')}}</mat-label>
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:user'"
                        matPrefix
                    ></mat-icon>
                    <input [formControlName]="'name'" matInput />
                </mat-form-field>
            </div>

            <!-- About -->
            <div class="sm:col-span-4">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>{{t('about')}}</mat-label>
                    <textarea
                        enabled="false"
                        matInput
                        [formControlName]="'about'"
                        cdkTextareaAutosize
                        [cdkAutosizeMinRows]="5"
                    ></textarea>
                </mat-form-field>
                <div class="text-hint mt-1 text-md">
                  {{t('about-explanation')}}
                </div>
            </div>
        </div>

        <!-- Divider -->
        <div class="my-10 border-t"></div>

        <!-- Section -->
        <div class="w-full">
            <div class="text-xl">{{t('personal-info')}}</div>
            <div class="text-secondary">
              {{t('personal-info-explanation')}}
            </div>
        </div>
        <div class="mt-8 grid w-full gap-6 sm:grid-cols-4">
            <!-- Email -->
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>{{t('email')}}</mat-label>
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:envelope'"
                        matPrefix
                    ></mat-icon>
                    <input [formControlName]="'email'" matInput />
                </mat-form-field>
            </div>
            <!-- Phone -->
            <div class="sm:col-span-2">
                <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
                    <mat-label>{{t('phone')}}</mat-label>
                    <mat-icon
                        class="icon-size-5"
                        [svgIcon]="'heroicons_solid:phone'"
                        matPrefix
                    ></mat-icon>
                    <input [formControlName]="'phone'" matInput />
                </mat-form-field>
            </div>
        </div>

        <!-- Divider -->
        <div class="mb-10 mt-11 border-t"></div>

        <!-- Actions -->
        <div class="flex items-center justify-end">
            <button mat-stroked-button type="button">{{t('cancel')}}</button>
            <button
                class="ml-4"
                mat-flat-button
                type="button"
                [color]="'primary'"
                (click)="saveProfile()"
            >
            {{t('save')}}
            </button>
        </div>
    </form>
</div>
